import { TypeToClassBaseValueConverter } from 'General/Resources/ValueConverters/TypeToClassBase';
export class TypeToClassValueConverter extends TypeToClassBaseValueConverter {

}